module.exports = __webpack_public_path__ + "media/images/flags/64/Zambia-cf74354ac7c3d8a06a1b046c1648c560.png";